import { Component, OnInit }  from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgForm }             from '@angular/forms';
import { TranslateService }   from '@ngx-translate/core';
import { UIRouter }           from '@uirouter/core';

import { LoginService }               from '../login/login.service';
import { MessagesService }            from '../../app-lite/messages/messages.service';
import { SessionService }             from '../../app-lite/sessions/session.service';
import { TwoFactorAuthSettingsModel } from './typings/two-factor-auth.settings';
import { UserModel }                  from '../../app-lite/users/typings/user';

@Component({
  selector   : 'two-factor-auth',
  template: require('./two-factor-auth.component.html')
})
export class TwoFactorAuthComponent implements OnInit {
  @BlockUI('twoFactorLoginBlock') block : NgBlockUI;

  settings : TwoFactorAuthSettingsModel = {
    otp    : null,
    user_id: null
  };

  user : UserModel;

  constructor (
    private loginService    : LoginService,
    private messagesService : MessagesService,
    private sessionService  : SessionService,
    private router          : UIRouter,
    private translateService: TranslateService,
  ) {}

  login ( form : NgForm ) : void {
    this.block.start();

    this.loginService.loginWithTwoFactorAuth(this.settings)
    .catch(error => {
      this.messagesService.error(error);

      setTimeout(() => {
        this.router.stateService.go('app.login');
      }, 3000);
    })
    .finally(() => {
      this.block.stop();

      this.sessionService.removeKey('user');
    });
  }

  ngOnInit () : void {
    this.user = this.sessionService.get('user');

    this.settings.user_id = this.user.id;
  }

  sendViaSms () : void {
    this.block.start();

    this.loginService.login({
      ...this.user,
      sms: true
    })
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.OTP_SENT'), 'success');

      this.router.stateService.go('app.two-factor-auth-login', undefined, {
        reload: true
      });
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
